<template>
  <div class="level-container">
    <div class="headline-container">
      <div class="adaption">
        <div class="headline himalaya">T<span>hree level linkage</span></div>
        <span class="title">三级联动监测&响应平台</span>
      </div>
    </div>
    <div class="level adaption">
      <div class="icon-text">
        <div>
          <img v-lazy="require('../../assets/index/level/icon.png')"/>
          <div class="text">向上汇报有依据</div>
        </div>
        <div>
          <img v-lazy="require('../../assets/index/level/icon.png')"/>
          <div class="text">日常管理有抓手</div>
        </div>
        <div>
          <img v-lazy="require('../../assets/index/level/icon.png')"/>
          <div class="text">安全事件能闭环</div>
        </div>
      </div>
      <div class="left-container">
        <div class="icon-div">
          <div>
            <span>国内仅有的高标准化SaaS平台，中心化交付技术</span>
            <img v-lazy="require('../../assets/index/level/icon1.png')"/>
          </div>
          <div>
            <span>具备持续跨行业、跨客户、快速复制、标准化输出的能力</span>
            <img v-lazy="require('../../assets/index/level/icon2.png')"/>
          </div>
          <div>
            <span>部署周期短，集团级信息中心统一维保</span>
            <img v-lazy="require('../../assets/index/level/icon3.png')"/>
          </div>
          <div>
            <span>建立企业网络状态可视能力，较小的投资快速提高其安全成熟度</span>
            <img v-lazy="require('../../assets/index/level/icon4.png')"/>
          </div>
        </div>
        <div class="scene-content">
          <svg @click="arrowClick('left')" class="arrow1" width="9" height="16" viewBox="0 0 9 16" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path :opacity="active === 0 ? 0.5 : 1" fill-rule="evenodd" clip-rule="evenodd"
                  d="M7.77817 0L0 7.77817L0.111328 7.8895L0.00083071 8L7.77901 15.7782L8.48611 15.0711L1.30372 7.88867L8.48528 0.707107L7.77817 0Z"
                  fill="white"/>
          </svg>
          <svg @click="arrowClick('right')" class="arrow2" width="9" height="16" viewBox="0 0 9 16"
               fill="none" xmlns="http://www.w3.org/2000/svg">
            <path :opacity="active + 1 === scene.length ? 0.5 : 1" fill-rule="evenodd" clip-rule="evenodd"
                  d="M0.70816 15.7782L8.48633 8.00002L8.37501 7.8887L8.4855 7.7782L0.70733 2.38419e-05L0.00022316 0.70713L7.18262 7.88953L0.00105381 15.0711L0.70816 15.7782Z"
                  fill="white"/>
          </svg>
          <span class="name">{{ scene[active].name }}</span>
          <span class="index">{{ active + 1 }}/{{ scene.length }}</span>
          <div class="value">{{ scene[active].value }}</div>
        </div>
      </div>
      <div class="right-container">
        <img v-lazy="require('../../assets/index/level/level3.png')"/>
        <p>数据驱动、在线预警、融合响应、平台与区域协同联动</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Level3",
  data() {
    return {
      active: 0,
      scene: [
        {
          name: "应用场景一",
          value: "某地区监管部门（例如: 某工信厅、某通管局）指导本行政区域内工业企业的安全工作，推进安全产业发展。建立本区域内的工业互联网威胁监测平台，为其管理区域内的企业提供安全监测预警服务支持。"
        },
        {
          name: "应用场景二",
          value: "工业互联网平台将其作为平台内的一个安全业务模块。对入驻平台的企业提供安全方案和远程安全服务。"
        },
        {
          name: "应用场景三",
          value: "安全运营商（电信、移动等运营商或者专门从事安全运营服务的运营商）建立安全监测平台，为客户提供安全运营服务。"
        },
        {
          name: "应用场景四",
          value: "集团型企业，有多个下属工厂或企业。在集团建立统一的威胁监测平台，对集团内的企业进行安全管理和管控。"
        },
        {
          name: "应用场景五",
          value: "行业管理单位或部门建立工业互联网威胁监测平台，掌握行业安全态势，为企业提供安全解决方案和安全服务。"
        }
      ]
    };
  },
  methods: {
    arrowClick(val) {
      if (val === "left") {
        if (this.active !== 0) {
          this.active -= 1;
        }
      } else if (this.active < this.scene.length - 1) {
        this.active += 1;
      }
    }
  }
};
</script>

<style scoped lang="less">
.level-container {
  background-color: #1e4086;
}

.headline-container {
  padding: 50px 0;
  color: #F4F8FF;
  background-color: #224895;

  .headline {
    height: 85px;
    font-size: 120px;

    span {
      font-size: 70px;
    }
  }

  .title {
    font-size: 36px;
  }
}

.level {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;

  .icon-text {
    display: flex;
    width: 100%;
    margin-top: 50px;
    margin-bottom: 30px;

    > div {
      display: flex;
      align-items: center;
      margin-left: 27px;
    }

    .text {
      margin-left: 5px;
      font-size: 14px;
      color: #F5B537;
    }
  }

  .left-container {
    width: calc(100% - 864px);

    .icon-div {
      display: flex;
      align-items: center;
      align-content: space-between;
      justify-content: space-between;
      flex-wrap: wrap;
      height: 290px;
      margin-top: 30px;

      > div {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: end;
        width: calc(50% - 7px);
        height: 140px;
        background: linear-gradient(104.17deg, rgba(255, 255, 255, 0.88) 1.31%, rgba(255, 255, 255, 0.33) 98.52%);
        border-radius: 16px 0;
        font-size: 18px;
        line-height: 132%;
        color: #224895;

        > span {
          position: absolute;
          width: 65%;
          left: 28px;
        }

        > img {
          align-self: end;
        }
      }
    }

    .scene-content {
      position: relative;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      align-content: start;
      padding: 10px 55px;
      width: 100%;
      height: 177px;
      margin-top: 35px;
      margin-bottom: 118px;
      border: 3px solid rgba(255, 255, 255, 0.5);
      border-radius: 16px 0;
      box-sizing: border-box;
      color: #FFFFFF;
      //.lg({
      //    padding: 10px 55px;
      //    height: 177px;
      //});
      //.md({
      //    padding: 10px 40px;
      //    height: 177px;
      //});
      //.sm({
      //    padding: 10px 30px;
      //    height: 210px;
      //});

      .name {
        font-size: 20px;
        font-weight: bold;
      }

      .index {
        font-size: 14px;
      }

      .value {
        margin-top: 10px;
        font-size: 16px;
        line-height: 150%;
        color: #F4F8FF;
        text-indent: 2em;
      }

      .arrow1 {
        position: absolute;
        left: 20px;
        cursor: pointer;
        //.md({
        //    left: 15px;
        //});
        //.sm({
        //    left: 10px;
        //});
      }

      .arrow2 {
        position: absolute;
        right: 20px;
        cursor: pointer;
        //.md({
        //    right: 15px;
        //});
        //.sm({
        //    right: 10px;
        //});
      }
    }
  }

  .right-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 844px;

    > p {
      font-size: 16px;
      line-height: 235%;
      color: #F4F8FF;
    }
  }
}
</style>
